<template>
  <section class="w-full flex justify-center">
    <div
      class="flex w-full flex-col gap-5 overflow-hidden rounded-[20px] border border-gray-border bg-white px-5 py-5 sm:min-h-[130px] sm:flex-row sm:items-center sm:justify-between sm:gap-10 sm:px-8 sm:py-6"
    >
      <div class="flex flex-col gap-3 sm:gap-4 z-10">
        <div class="flex flex-col gap-3 sm:gap-2">
          <h2 class="text-[20px] sm:text-[20px] font-helvetica-700 text-gray-dark font-bold">
            Не нашли нужный товар?
          </h2>
          <p class="text-[16px] sm:text-[16px] text-gray-dark">
            Попробуйте изменить критерии поиска
          </p>
        </div>
      </div>

      <div class="flex justify-end sm:min-w-[140px]">
        <SvgoIcon name="g-icon:nogoods" class="h-[88px] w-auto text-gray-light sm:h-full sm:max-h-[140px]" />
      </div>
    </div>
  </section>
</template>
